import { render } from "./Basicinfo.vue?vue&type=template&id=13d16afe&scoped=true"
import script from "./Basicinfo.vue?vue&type=script&lang=ts"
export * from "./Basicinfo.vue?vue&type=script&lang=ts"

import "./Basicinfo.vue?vue&type=style&index=0&id=13d16afe&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-13d16afe"

export default script